import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  Drawer,
  Input,
  Progress,
  Row,
  Select,
} from 'antd';
import { notification } from '../../../../utils/messaging';
import { BackButtonLayout } from '../../../../containers/BackButtonLayout';
import './asset/css/crossing.css';
import axios from 'axios';
import train from './asset/images/train.png';
import service from './asset/images/customer-service.svg';
import { MENU } from '../../../../AppConstants';
import { useDispatch, useSelector } from 'react-redux';
import noImage from '../../../common/assets/images/no-photo.jpg';

import moment from 'moment';
import dayjs from 'dayjs';
import { usePostEnquiryMutation } from './crossingSlice';

const { TOGGLE_CATCH_REPORT, TOGGLE_AP_CROSSING } = MENU;
const ApCrossing = () => {
  const dispatch = useDispatch();

  const [isSucess, setIsSucess] = useState(false);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    route: null,
    vehicleType: null,
    vehicleRegistration: '',
    peopleCount: '',
  });

  const [sendEnquiry, { isLoading: isLoading }] = usePostEnquiryMutation();
  const { showCrossingDrawer } = useSelector((state) => state.Menu);
  const isOpen = showCrossingDrawer;
  const resetForm = () => {
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      route: null,
      vehicleType: null,
      vehicleRegistration: '',
      peopleCount: '',
    });
  };
  const sendReport = () => {
    let payload_data = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      phone_number: formData?.phone,
      preferred_route: formData?.route,
      vehicle_type: formData?.vehicleType,
      vehicle_registration: formData?.vehicleRegistration,
      no_of_people: formData?.peopleCount,
    };
    sendEnquiry(payload_data)
      .unwrap()
      .then(() => {
        setIsSucess(true);
        resetForm();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (!document) {
      return;
    }
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isOpen]);
  const handleInputChange = (field) => (e) => {
    const value = e?.target?.value ?? e; // works for both Input and Select
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Drawer
      title={null}
      footer={null}
      closeable={false}
      maskCloseable={false}
      className='ap__drawer'
      open={isOpen}
      onClose={() => {
        dispatch({
          type: TOGGLE_AP_CROSSING,
          showCrossingDrawer: false,
        });
        resetForm();
        setIsSucess(false);
      }}
    >
      <BackButtonLayout
        useCrossIcon
        overlapHeader={true}
        onBack={() => {
          dispatch({
            type: TOGGLE_AP_CROSSING,
            showCrossingDrawer: false,
          });
          resetForm();
          setIsSucess(false);
        }}
      >
        <div
          className={` ${
            // current > 2 ? ' sb-blue-bg' : 'main_container_padding'
            'main_container_padding'
          }`}
          style={{
            display: 'flex',
            'flex-direction': 'column',
            'justify-content': 'space-between',
            minHeight: '100vh',
          }}
        >
          {/* {current > 2 ? (
            <Success />
          ) : ( */}
          <React.Fragment>
            <div className={'main_container_padding__content w-full'}>
              <div className='row-center justify-end mg-top-25'>
                <div className='br30 white gBold  ap-crossing-new fs-12 justify-center center'>
                  NEW
                </div>
              </div>
              <div
                className='mg-top-20  '
                // style={{ border: '3px solid #AAD2F2' }}
              >
                <img
                  src={train}
                  alt='train'
                  width={330}
                  height={210}
                  className='br20'
                  style={{
                    width: '100%',
                    border: '3px solid #AAD2F2',
                    'object-position': 'bottom',
                    'object-fit': 'cover',
                  }}
                />
              </div>
              {isSucess ? (
                <div>
                  <div className='fs-22 gBold txt-center mg-bottom-20 mg-top-20'>
                    Enquiry Received!
                  </div>
                  <div className='center mg-bottom-30'>
                    <img src={service} alt='customer-service' />
                  </div>
                  <div className='gMedium fs-15 mg-bottom-20 txt-center grey-800 '>
                    Our crossings handler will be in touch as soon as possible
                    to process your application and help secure your crossing!
                  </div>
                  <div className='gMedium fs-15 txt-center grey-800 mg-bottom-30'>
                    Any questions in the meantime? Contact swimbooker support.
                  </div>
                  <Button
                    className={
                      '  gBold brFull w-full h-fit fs-18 white txt-center  pd-10 pd-left-28 pd-right-28 fr'
                    }
                    style={{
                      background:
                        'linear-gradient(90deg, #008A55 0%, #00C477 100%)',
                      'box-shadow': '0px 4px 4px 0px rgba(0, 0, 0, 0.09)',
                    }}
                    onClick={() => {
                      setIsSucess(false);
                    }}
                  >
                    New Enquiry
                  </Button>
                </div>
              ) : (
                <div>
                  <div className='mg-top-30 fs-22 gBold'>
                    We help secure the cheapest crossings ✅
                  </div>
                  <div className='fs-15 gMedium mg-bottom-15'>
                    We’ve secured an exclusive partnership to help secure the
                    best value crossings between the UK & Europe! Fill out the
                    form below to find out more.
                  </div>
                  <div className='gBold fs-16 sb-blue-500 mg-bottom-15'>
                    Crossing Application Form
                  </div>
                  <Row gutter={[10, 10]}>
                    <Col span={12}>
                      <Input
                        className='ap-input'
                        placeholder='First Name'
                        value={formData.firstName}
                        onChange={handleInputChange('firstName')}
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        className='ap-input'
                        placeholder='Last Name'
                        value={formData.lastName}
                        onChange={handleInputChange('lastName')}
                      />
                    </Col>
                    <Col span={24}>
                      <Input
                        className='ap-input'
                        placeholder='Email Address'
                        value={formData.email}
                        onChange={handleInputChange('email')}
                      />
                    </Col>
                    <Col span={24}>
                      <Input
                        className='ap-input'
                        type='number'
                        placeholder='Phone Number'
                        value={formData.phone}
                        onChange={handleInputChange('phone')}
                      />
                    </Col>
                    <Col span={24}>
                      <Select
                        className='ap-select w-full'
                        placeholder='Preffered Route?'
                        value={formData.route}
                        onChange={handleInputChange('route')}
                      >
                        <Select.Option
                          className='gMedium'
                          value='Tunnel Folkestone-Calais'
                        >
                          Tunnel Folkestone-Calais
                        </Select.Option>
                        <Select.Option
                          className='gMedium'
                          value='Ferry Dover-Calais'
                        >
                          Ferry Dover-Calais
                        </Select.Option>
                        <Select.Option
                          className='gMedium'
                          value='Ferry Dover-Dunkirk'
                        >
                          Ferry Dover-Dunkirk
                        </Select.Option>
                        <Select.Option className='gMedium' value='Any'>
                          Any
                        </Select.Option>
                      </Select>
                    </Col>
                    <Col span={24}>
                      <Select
                        className='ap-select w-full'
                        placeholder='Vehicle Type'
                        value={formData.vehicleType}
                        onChange={handleInputChange('vehicleType')}
                      >
                        <Select.Option className='gMedium' value='Car'>
                          Car
                        </Select.Option>
                        <Select.Option className='gMedium' value='Van'>
                          Van
                        </Select.Option>
                        <Select.Option className='gMedium' value='Other'>
                          Other
                        </Select.Option>
                      </Select>
                    </Col>
                    <Col span={24}>
                      <Input
                        className='ap-input'
                        placeholder='Vehicle Registration'
                        value={formData.vehicleRegistration}
                        onChange={handleInputChange('vehicleRegistration')}
                      />
                    </Col>
                    <Col span={24}>
                      <Input
                        className='ap-input'
                        type='number'
                        placeholder='Number of People Travelling'
                        value={formData.peopleCount}
                        onChange={handleInputChange('peopleCount')}
                      />
                    </Col>
                  </Row>

                  <div style={{}} className='mg-top-15'>
                    <Row>
                      <div className='fs-12 gSemiBold txt-center seagreen-600 w-full mg-bottom-10'>
                        Our team will contact you for further details!
                      </div>
                      <Col span={24}>
                        <Button
                          className={
                            ' gBold brFull w-full h-fit fs-18 white txt-center mg-bottom-10  pd-10 pd-left-28 pd-right-28 fr'
                          }
                          style={{
                            background:
                              'linear-gradient(90deg, #008A55 0%, #00C477 100%)',
                            'box-shadow': '0px 4px 4px 0px rgba(0, 0, 0, 0.09)',
                          }}
                          onClick={() => {
                            const isEmailValid = (email) =>
                              /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); // Simple email regex

                            const hasEmptyField = Object.entries(formData).some(
                              ([key, val]) => {
                                if (key === 'email') {
                                  return !val || !isEmailValid(val); // invalid or empty email
                                }
                                return val === '' || val === null;
                              }
                            );

                            if (hasEmptyField) {
                              notification.warning({
                                description:
                                  'Please fill all the fields correctly.',
                              });
                            } else {
                              sendReport();
                            }
                          }}
                          loading={isLoading}
                        >
                          Send Enquiry
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              )}
            </div>
          </React.Fragment>
        </div>
      </BackButtonLayout>
    </Drawer>
  );
};
export default ApCrossing;
